export const newShipping = (shipping) => ({
  type: 'NEW_SHIPPING',
  shipping: shipping
})

export const resetShipping = () => ({
  type: 'RESET_SHIPPING'
})



// WEBPACK FOOTER //
// ./src/actions/shipping.js